import React from 'react';
import logoSvg from '../assets/logo.svg';
import logoDarkSvg from '../assets/logo-dark.svg';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large' | 'xl' | 'icon';
  className?: string;
  showText?: boolean;
  variant?: 'default' | 'dark';
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'large', 
  className = '',
  showText = true, // Reserved for future text display functionality
  variant = 'default'
}) => {
  const logoSrc = variant === 'dark' ? logoDarkSvg : logoSvg;
  
  // Map size prop to CSS class
  const sizeClass = `logo-${size}`;
  
  return (
    <div className={`logo-container ${sizeClass} ${className}`}>
      <img 
        src={logoSrc}
        alt="MPM Medical Logo"
        className="mpm-logo"
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};

export default Logo;
